import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
//import Logo from './img/logo.png';
import Logo from './img/abys_logo_bg.png';
import { Link, useLocation } from 'react-router-dom';
import './styles/Login.css';
import './styles/il.css';
import kakao_png from './img/kakao_icon.png'
import naver_png from './img/naver_icon.png'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, TabContent, TabPane, Nav, NavItem, NavLink, Card, CardTitle, CardText } from 'reactstrap';
import classnames from 'classnames';
import google_png from './img/google_icon.png';
import apple_png from './img/apple.png';
import { Cookies } from 'react-cookie';
import { instance } from './common';
import Register from './Register';
import { useMediaQuery } from "react-responsive";
const { Kakao, naver } = window;
Kakao.init('daab8ad5782acb21137612fff03ff51b');

function fun_login(seq) {
    if (window.Android) {
        console.log("android_start", seq);
        window.Android.login(seq);
    } else if (window.webkit) {
        var result =
        {
            "seq": seq,
        };
        window.webkit.messageHandlers.Login.postMessage(result);
    }

}


function AppleShow() {
    const appleLogin = () => {
        var send =
        {
            "alogin": "11",
        };
        window.webkit.messageHandlers.AppleLogin.postMessage(send);
    }

    return (


        <img src={apple_png} className="ml-3" style={{ width: '15%' }} onClick={appleLogin} />

    )

}



function Google() {
    const googleLoginBtn = useRef(null);
    const [token, setToken] = useState("");


    const andCheck = () => {
        if (window.Android && window.Android.googlelogin) {
            window.Android.googlelogin();

        } else if (window.webkit
            && window.webkit.messageHandlers
            && window.webkit.messageHandlers.GoogleLogin) {
            let send =
                { "alogin": "11" };
            window.webkit.messageHandlers.GoogleLogin.postMessage(send)
        } else {
            googleSDK();

        }

    }

    //SDK 초기 설정 및 내 API초기화
    const googleSDK = () => {
        window.googleSDKLoaded = () => {
            console.log(window.gapi);
            /////
            window.gapi.load("auth2", () => {
                const auth2 = window.gapi.auth2.init({
                    client_id:
                        "187584030967-ruu2v1v1a2flmdics1lvgej3hjmfdmrh.apps.googleusercontent.com",
                    scope: "profile email",
                });
                //버튼 클릭시 사용자 정보 불러오기
                auth2.attachClickHandler(
                    googleLoginBtn.current,
                    {},
                    (googleUser) => {
                        const profile = googleUser.getBasicProfile();
                        console.log(profile);
                        console.log(`Token || ${googleUser.getAuthResponse().id_token}`);
                        setToken(googleUser.getAuthResponse().id_token);
                        console.log(`ID: ${profile.getId()}`);
                        console.log(`Name: ${profile.getName()}`);
                        console.log(`Image URL: ${profile.getImageUrl()}`);
                        console.log(`Email: ${profile.getEmail()}`);
                        let kind = 'google';
                        let obj = {
                            u_login_id: profile.getEmail()
                        }
                        const fetchData = async () => {
                            instance.post('/users/id', obj).then(function (res) {
                                if (res.data.length == 0) {
                                    alert('등록되지 않은 계정입니다. 회원가입 페이지로 이동합니다.');
                                    window.location.replace('/join?kind=' + kind + '&social_email=' + profile.getEmail());
                                } else {
                                    alert(res.data[0].u_nick + "님의 로그인이 성공하였습니다.");
                                    window.sessionStorage.setItem('isLogin', true);
                                    window.sessionStorage.setItem('result', JSON.stringify(res.data[0]));
                                    fun_login(res.data[0].u_login_id);
                                    window.location.replace('/');
                                }
                            });

                        };

                        fetchData();
                    },
                    (error) => {
                        alert(JSON.stringify(error, undefined, 2));
                    }
                );
            });


            ///////
        };
        //구글 SDK 불러오기
        (function (d, s, id) {
            let js;
            const fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = "https://apis.google.com/js/platform.js?onload=googleSDKLoaded";
            fjs.parentNode.insertBefore(js, fjs);


        })(document, "script", "google-jssdk");


    };

    return (
        <div id="gSignInWrapper" style={{ width: '15%', display: 'inline-block' }} onClick={andCheck}>
            <span className="label" />
            <div ref={googleLoginBtn} id="customBtn" className="customGPlusSignIn">
                <img src={google_png} style={{ width: '100%' }} />
            </div>
        </div>
    );
}



function ModalShow({ toggle, modal, setModal, title }) {

    const [inputs, setInputs] = useState({
        u_phone: '',
    });

    const onChange = (e) => {
        const { name, value } = e.target;
        setInputs({
            ...inputs,
            [name]: value
        })

    }
    const { u_phone } = inputs;

    const [isCheck, setCheck] = useState(false);
    const [data, setData] = useState([]);
    const findId = () => {
        let obj = { u_phone: u_phone }
        const fetchData = async () => {
            instance.post('/users/search-id', obj).then(function (res) {
                console.log('res : ', res.data)

                setData(res.data);
                if (res.data.length != 0) {
                    setCheck(true);
                } else {
                    setCheck(false);
                    alert('조회된 아이디가 없습니다.');
                    setModal(!modal)
                }

            });

        };

        fetchData();

    }



    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle}> {title}</ModalHeader>
            <ModalBody>
                <label>전화번호</label>
                <input name="u_phone" value={u_phone} onChange={onChange} type="text" className="form-control" />
                <span className="idcheck_span" onClick={findId}>찾기</span>
                {

                    <div>
                        {
                            isCheck
                                ?
                                data.length != 0
                                && data.map((v, i) =>
                                (i === 0
                                    ? <><div className="font-weight-bold">조회된 아이디 : </div><label className="mr-2">{v.u_login_id}</label></>
                                    : <label>{v.u_login_id}</label>)
                                )
                                :
                                <span></span>


                        }
                    </div>
                }
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>닫기</Button>{' '}

            </ModalFooter>
        </Modal>

    )
}

function ModalShow2({ toggle, modal, setModal, title }) {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);


    const [inputs, setInputs] = useState({
        u_login_id: '',

    });

    const onChange = (e) => {
        const { name, value } = e.target;
        setInputs({
            ...inputs,
            [name]: value
        })

    }
    const { u_login_id } = inputs;


    const [isCheck, setCheck] = useState(false);
    const [data, setData] = useState([]);
    const findId = () => {
        let obj = { u_login_id: u_login_id }
        const fetchData = async () => {
            instance.post('/users/search-forpw', obj).then(function (res) {
                console.log('res : ', res.data)

                setData(res.data);
                if (res.data.length != 0) {
                    setCheck(true);
                } else {
                    setCheck(false);
                    alert('조회된 아이디가 없습니다.');
                }

            });

        };

        fetchData();

    }
    console.log('data :', data)

    const [inputs2, setInputs2] = useState({
        u_pwd: '',
        u_pwd2: '',
    });

    const [pwCheck, setpwCheck] = useState(false);
    const onChange2 = (e) => {
        const { name, value } = e.target;
        setInputs2({
            ...inputs2,
            [name]: value
        })

    }
    const { u_pwd, u_pwd2 } = inputs2;

    const updatePw = () => {
        if (u_pwd2 != u_pwd) {
            alert('비밀번호가 일치하지 않습니다.')
        } else {
            let obj = { u_pwd: u_pwd, u_login_id: u_login_id }
            const fetchData = async () => {
                instance.post('/users/update/pwd', obj).then(function (res) {
                    console.log('res : ', res.data)

                    setData(res.data);

                    alert('비밀번호가 수정되었습니다.');
                    setModal(!modal)


                });

            };

            fetchData();


        }

    }


    return (
        <Modal isOpen={modal} toggle={toggle} >
            <ModalHeader toggle={toggle}> {title}</ModalHeader>
            <ModalBody>
                <label>아이디</label>
                <input name="u_login_id" value={u_login_id} onChange={onChange} type="text" className="form-control" />
                <span className="idcheck_span" onClick={findId}>찾기</span>
                {

                    <div>
                        {
                            isCheck
                                ?
                                data.length != 0


                                    ? <><label>비밀번호</label>
                                        <input name="u_pwd" value={u_pwd} onChange={onChange2} type="password" className="form-control" />
                                        <label className="mt-2">수정할 비밀번호</label>
                                        <input name="u_pwd2" value={u_pwd2} onChange={onChange2} type="password" className="form-control" />

                                    </>
                                    : <label></label>

                                :
                                <span></span>


                        }
                    </div>
                }
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>취소</Button>{' '}
                <Button color="primary" onClick={updatePw}>수정</Button>{' '}

            </ModalFooter>
        </Modal>

    )
}

function ModalShow3({ toggle, modal, setModal }) {

    
    const [inputs, setInputs] = useState({
        u_phone: '',
    });

    const onChange = (e) => {
        const { name, value } = e.target;
        setInputs({
            ...inputs,
            [name]: value
        })

    }
    const { u_phone } = inputs;

    const [isCheck, setCheck] = useState(false);
    const [data, setData] = useState([]);
    const findId = () => {
        let obj = { u_phone: u_phone }
        const fetchData = async () => {
            instance.post('/users/search-id', obj).then(function (res) {
                console.log('res : ', res.data)

                setData(res.data);
                if (res.data.length != 0) {
                    setCheck(true);
                } else {
                    setCheck(false);
                    alert('조회된 아이디가 없습니다.');
                    setModal(!modal)
                }

            });

        };

        fetchData();

    }
    

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);


    const [inputs3, setInputs3] = useState({
        u_login_id: '',

    });

    const onChange3 = (e) => {
        const { name, value } = e.target;
        setInputs3({
            ...inputs3,
            [name]: value
        })

    }
    const { u_login_id } = inputs3;


    const [isCheck3, setCheck3] = useState(false);
    const [data3, setData3] = useState([]);
    const findId3 = () => {
        let obj = { u_login_id: u_login_id }
        const fetchData = async () => {
            instance.post('/users/search-forpw', obj).then(function (res) {
                console.log('res : ', res.data)

                setData3(res.data);
                if (res.data.length != 0) {
                    setCheck3(true);
                } else {
                    setCheck3(false);
                    alert('조회된 아이디가 없습니다.');
                }

            });

        };

        fetchData();

    }
    console.log('data :', data)

    const [inputs2, setInputs2] = useState({
        u_pwd: '',
        u_pwd2: '',
    });

    const [pwCheck, setpwCheck] = useState(false);
    const onChange2 = (e) => {
        const { name, value } = e.target;
        setInputs2({
            ...inputs2,
            [name]: value
        })

    }
    const { u_pwd, u_pwd2 } = inputs2;

    const updatePw = () => {
        if (u_pwd2 != u_pwd) {
            alert('비밀번호가 일치하지 않습니다.')
        } else {
            let obj = { u_pwd: u_pwd, u_login_id: u_login_id }
            const fetchData = async () => {
                instance.post('/users/update/pwd', obj).then(function (res) {
                    console.log('res : ', res.data)

                    setData3(res.data);

                    alert('비밀번호가 수정되었습니다.');
                    setModal(!modal)


                });

            };

            fetchData();


        }

    }

    const [activeTab, setActiveTab] = useState('1');
    const tabToggle = (tab) => {
        if(activeTab !== tab) setActiveTab(tab);
    }

    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle}></ModalHeader>
            <ModalBody>
            <Nav tabs>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === '1' })}
                                onClick={() => { tabToggle('1'); }}
                            >
                                아이디 찾기
                        </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === '2' })}
                                onClick={() => { tabToggle('2'); }}
                            >
                                비밀번호 재설정
                        </NavLink>
                        </NavItem>
                    </Nav>
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="1">
                            <div className="py-5">
                                <label>전화번호</label>
                                <input name="u_phone" value={u_phone} onChange={onChange} type="text" className="form-control" />
                                <span className="idcheck_span" onClick={findId}>찾기</span>
                                {

                                    <div>
                                        {
                                            isCheck
                                                ?
                                                data.length != 0
                                                && data.map((v, i) =>
                                                (i === 0
                                                    ? <><div className="font-weight-bold">조회된 아이디 : </div><label className="mr-2">{v.u_login_id}</label></>
                                                    : <label>{v.u_login_id}</label>)
                                                )
                                                :
                                                <span></span>


                                        }
                                    </div>
                                }
                            </div>                        
                        </TabPane>
                        <TabPane tabId="2">
                            <div className="row py-5 px-0">
                               <div className="col-12 px-0">
                               <label>아이디</label>
                                    <input name="u_login_id" value={u_login_id} onChange={onChange} type="text" className="form-control" />
                                    <span className="idcheck_span2" onClick={findId}>찾기</span>
                                    {

                                        <div>
                                            {
                                                isCheck
                                                    ?
                                                    data.length != 0


                                                        ? <><label>비밀번호</label>
                                                            <input name="u_pwd" value={u_pwd} onChange={onChange2} type="password" className="form-control" />
                                                            <label className="mt-2">수정할 비밀번호</label>
                                                            <input name="u_pwd2" value={u_pwd2} onChange={onChange2} type="password" className="form-control" />

                                                        </>
                                                        : <label></label>

                                                    :
                                                    <span></span>


                                            }
                                        </div>
                                    }
                               </div>
                            </div>
                        </TabPane>
                    </TabContent>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>닫기</Button>{' '}

            </ModalFooter>
        </Modal>

    )
}


function NaverButton(props: naver) {

    const location = useLocation();

    const getNaverToken = () => {
        if (!location.hash) return;
        const token = location.hash.split('=')[1].split('&')[0];
        console.log('token : ', token);
        if (token) {
            const cookies = new Cookies();
            const expires = new Date()
            expires.setDate(expires.getDate() + 14)
            cookies.set('naver_token', token, { path: '/', expires });
        }
    };

    const initializeNaverLogin = () => {
        let kind = 'naver';
        const naverLogin = new naver.LoginWithNaverId({
            clientId: 'd6cnZVQYa0lNNzRGDEPe',
            callbackUrl: 'https://abys-service.co.kr/login',
            isPopup: false, // popup 형식으로 띄울것인지 설정
            loginButton: { color: 'white', type: 1, height: '47' }, //버튼의 스타일, 타입, 크기를 지정
        });
        naverLogin.init();

        naverLogin.getLoginStatus(function (status) {
            console.log('status : ', status);
            if (status) {


                var email = naverLogin.user.getEmail();
                console.log('email : ', email)

                let obj = {
                    u_login_id: email
                }
                const fetchData = async () => {
                    instance.post('/users/id', obj).then(function (res) {
                        if (res.data.length == 0) {
                            alert('등록되지 않은 계정입니다. 회원가입 페이지로 이동합니다.');
                            window.location.replace('/join?kind=' + kind + '&social_email=' + email);
                        } else {
                            alert(res.data[0].u_nick + "님의 로그인이 성공하였습니다.");
                            window.sessionStorage.setItem('isLogin', true);
                            window.sessionStorage.setItem('result', JSON.stringify(res.data[0]));
                            fun_login(res.data[0].u_login_id);
                            window.location.replace('/');

                        }
                    });

                };

                fetchData();



            } else {
                console.log("callback 처리에 실패하였습니다.");
            }
        });
    };

    useEffect(() => {
        initializeNaverLogin();
        getNaverToken();


    }, []);

    return (
        <div id='naverIdLogin' className="d-none" />
    )
}


function Login({ history }) {

    const [modal, setModal] = useState(false);
    const [modal2, setModal2] = useState(false);
    const [modal3, setModal3] = useState(false);

    const toggle = () => {
        setModal(!modal);
    }

    const toggle2 = () => {
        setModal2(!modal2);
    }


    const ab = {
        position: 'absolute'
    }
    const Isalert = () => {
        alert("업데이트 준비중입니다.");
    }
    const [isRadio, setIsRadio] = useState('회원');

    const radioSet = (e) => {
        const { value } = e.target;
        setIsRadio(value);
    }

    console.log('isRadio : ', isRadio)

    const [inputs, setInputs] = useState({
        u_login_id: '',
        u_pwd: '',
    });

    const onChange = (e) => {
        const { name, value } = e.target;
        setInputs({
            ...inputs,
            [name]: value
        })
    }
    const [checked, setChecked] = useState(false);

    const checkedHandler = () => {
        if (checked == false) {
            setChecked(true);
        } else {
            setChecked(false);
        }
        console.log('checked : ', checked);
    }

    const onAlert = () => {
        alert("서비스 준비중입니다.");
    }

    const { u_login_id, u_pwd } = inputs;

    const login = () => {
        instance.post('/users/login', {
            params: {
                obj: inputs,
            }
        })
            .then(function (response) {
                // handle success
                let { result } = response.data;
                console.log('result ? ', JSON.stringify(result));
                if (result === 'wrong_pwd') {
                    alert('비밀번호가 틀리셨습니다. 다시 입력해주세요.');
                } else if (result === 'not_found') {
                    alert('존재하지 않은 회원 정보입니다.');
                } else {
                    console.log('result : ', result);
                    alert(result.u_nick + "님의 로그인이 성공하였습니다.");
                    window.sessionStorage.setItem('isLogin', true);
                    window.sessionStorage.setItem('result', JSON.stringify(result));
                    fun_login(result.u_login_id);

                    window.location.replace('/');
                }
                const cookies = new Cookies();
                const expires = new Date()
                expires.setDate(expires.getDate() + 14)
                const autoObj = {
                    u_id: result.u_id,
                    u_type: result.u_type,
                    u_login_id: result.u_login_id,
                    u_nick: result.u_nick,
                    u_email: result.u_email,
                    u_phone: result.u_phone,
                    u_address1: result.u_address1,
                    u_address2: result.u_address2,
                    u_account: result.u_account,
                    u_agency_lat: result.u_agency_lat,
                    u_agency_long: result.u_agency_long,
                    u_agency_name: result.u_agency_name,
                    u_agency_tel: result.u_agency_tel,
                    u_agency_url: result.u_agency_url,
                    u_agree: result.u_agree,
                    u_area: result.u_area,
                    u_bank: result.u_bank,
                    u_chonpan: result.u_chonpan,
                    u_chonpan_rep: result.u_chonpan_rep,
                    u_dealer_agency: result.u_dealer_agency,
                    u_holder: result.u_holder,
                    u_name: result.u_name,
                    u_profile: result.u_profile,
                    u_sigong: result.u_sigong,
                    u_social: result.u_social,
                    u_uuid: result.u_uuid
                }
                if (checked === true) {
                    cookies.set('isAutoLogin', JSON.stringify(autoObj), { path: '/', expires });
                }
            })
            .catch(function (error) {
                // handle error
                console.log(error);
            })
    }


    const pbS = {
        paddingBottom: '50px'
    }


    const kakao_login = () => {

        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.KakaoLogin) {
            var send =
            {
                "alogin": "11",
            };
            window.webkit.messageHandlers.KakaoLogin.postMessage(send);
        } else {
            let kind = 'kakao';
            Kakao.Auth.login({
                success: function (response) {
                    console.log('response : ', response);
                    Kakao.API.request({
                        url: "/v2/user/me",
                        success: function (res) {
                            console.log('res : ', res);
                            console.log(res.kakao_account.email);

                            emailCheck(res.kakao_account.email, kind);
                        },
                        fail: function (error) {
                            alert(JSON.stringify(error))
                        }
                    });
                },
                fail: function (error) {
                    console.log(error);
                },
            });
        }

    }

    const naverLogin = () => {
        document.getElementById('naverIdLogin_loginButton').click();
    }

    const emailCheck = (target, kind) => {
        let obj = {
            u_login_id: target
        }
        const fetchData = async () => {
            instance.post('/users/id', obj).then(function (res) {
                if (res.data.length == 0) {
                    alert('등록되지 않은 계정입니다. 회원가입 페이지로 이동합니다.');
                    history.push('/join?kind=' + kind + '&social_email=' + target);
                } else {
                    alert(res.data[0].u_nick + "님의 로그인이 성공하였습니다.");
                    window.sessionStorage.setItem('isLogin', true);
                    window.sessionStorage.setItem('result', JSON.stringify(res.data[0]));
                    console.log('res.data[0].u_type : ', res.data[0].u_type);
                    fun_login(res.data[0].u_login_id);
                    window.location.replace('/');

                }
            });

        };

        fetchData();
    }

    const [activeTab, setActiveTab] = useState('1');
    const tabToggle = (tab) => {
        if(activeTab !== tab) setActiveTab(tab);
    }

    const isPc = useMediaQuery({
        query : "(min-width:768px)"
      });
    const isMobile = useMediaQuery({
        query : "(max-width:767px)"
    });

    const findToggle = (e) =>{
        setModal3(!modal3);
    }
    

    useEffect(() => {
        if(document.getElementById('mobile-header')){
            document.getElementById('mobile-header').classList.add('d-none');

        }
        
        return () => {
            if(document.getElementById('mobile-header')){
                document.getElementById('mobile-header').classList.remove('d-none');
            }
            
        }
    },[])
    return (
        <>
            <div>
                <div className="logo">
                    <img style={{width:'85px'}} className="logimg" src={Logo} onClick={() => window.location.replace('/')}></img>
                </div>
                <div className="tabmenu container text-center mx-auto">
                    <Nav tabs>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === '1' })}
                                onClick={() => { tabToggle('1'); }}
                            >
                                로그인
                        </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === '2' })}
                                onClick={() => { tabToggle('2'); }}
                            >
                                회원가입
                        </NavLink>
                        </NavItem>
                    </Nav>
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="1">
                            <div className="row">
                                <div className="col-12">
                                    <div className="login-form text-left">
                                        <div className="mb-5">
                                            <div className="input">아이디</div>
                                            <input name="u_login_id" className="userIdlogin" type="text" onChange={onChange} value={u_login_id} />
                                        </div>
                                        <div>
                                            <div className="input">비밀번호</div>
                                            <input name="u_pwd" className="password" type="password" onChange={onChange} value={u_pwd} />
                                        </div>                                        
                                    </div>
                                    <div className="text-left pl-0 mt-5"><input type="checkbox" name="autoLogin" className="mr-1" onChange={checkedHandler} />자동로그인</div>
                                    <div className="loginbtn">
                                        <button type="button" className="btn  btn-primary text-white w-100 btn_pad" onClick={login}>로그인</button>
                                    </div>
                                    <div className="find col-12">
                                        <span className="col-xs-6 findid ml-5" onClick={findToggle} data-name="아이디 찾기">아이디 찾기</span>
                                        <span className="col-xs-6 findpw px-0" onClick={findToggle} data-name="비밀번호 재설정">비밀번호 재설정</span>
                                    </div>
                                    <div className="ft mb-5">
                                        <img src={kakao_png} className="mr-3" onClick={onAlert} style={{ width: '15%' }} onClick={kakao_login} />
                                        <NaverButton />
                                        <img src={naver_png} className="mr-3" onClick={onAlert} style={{ width: '15%' }} onClick={naverLogin} />
                                        <Google />

                                        {
                                            (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.AppleLogin)
                                            && <AppleShow />

                                        }
                                    </div>
                                    <div className="bottom_txt">
                                        <p>- 회원가입 및 앱 설치 시 진행상황 알림을 받아보실 수 있습니다.</p>
                                        <p className="mb-3">- 회원가입 시 품질보증서 발급을 받으실 수 있습니다.</p>
                                        <p>회원가입시 아비스의 서비스 이용약관과 개인정보 보호정책에 동의하게 됩니다.</p>
                                    </div>
                                </div>
                            </div>
                        </TabPane>
                        <TabPane tabId="2">
                            <div className="row px-0">
                               <div className="col-12 px-0">
                                   <Register history={history} />
                               </div>
                            </div>
                        </TabPane>
                    </TabContent>
                </div>
                {/* <div className="container text-right" style={ab}>
                    <input onChange={radioSet} id="r-chk1" className="mr-3" type="radio" name="radio_chk" value="회원" checked="checked" readOnly />
                    <label htmlFor="r-chk1" className="mr-3">회원</label>
                    <input onChange={Isalert} id="r-chk2" className="mr-3" type="radio" name="radio_chk" value="계약번호" />
                    <label htmlFor="r-chk2">계약번호 로그인</label>
                </div> */}
                <div className="container m_Login2">
                    <div className="">
                        <div className="Login">
                            <div className="login-form">
                                <div className="input">아이디</div>
                                <input name="u_login_id" className="userIdlogin" type="text" onChange={onChange} value={u_login_id} />
                                <div className="input">비밀번호</div>
                                <input name="u_pwd" className="password" type="password" onChange={onChange} value={u_pwd} />
                                <div className="text-left pl-0 mt-5"><input type="checkbox" name="autoLogin" className="mr-1" onChange={checkedHandler} />자동로그인</div>
                            </div>
                            <div className="loginbtn">
                                <button type="button" className="btn  btn-primary text-white w-100 btn_pad" onClick={login}>로그인</button>
                            </div>
                            <div className="find">
                                <span className="col-xs-6 findid" onClick={toggle} data-name="아이디 찾기">아이디 찾기</span>
                                <span className="col-xs-6 findpw" onClick={toggle2} data-name="비밀번호 재설정">비밀번호 재설정</span>                      
                            </div>
                        </div>
                        <div className="ft">
                            <img src={kakao_png} className="mr-3" onClick={onAlert} style={{ width: '15%' }} onClick={kakao_login} />
                            <NaverButton />
                            <img src={naver_png} className="mr-3" onClick={onAlert} style={{ width: '15%' }} onClick={naverLogin} />
                            <Google />

                            {
                                (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.AppleLogin)
                                && <AppleShow />

                            }
                        </div>
                        <div className="text-center mt-5 text-lightgray" style={pbS}>
                            <span className="joinBtn">
                                ABYS 가입으로 다양한 서비스를 받아보세요.<br />
                                <Link to="/join" className="text-lightgray">
                                    <span className="font-weight-bold border-bottom"> 회원가입</span>
                                </Link>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                {/* 등록/수정 모달 */}
                <ModalShow modal={modal} setModal={setModal} toggle={toggle} title="아이디 찾기" />
                <ModalShow2 modal={modal2} setModal={setModal2} toggle={toggle2} title="비밀번호 찾기" />
                <ModalShow3 modal={modal3} setModal={setModal3} toggle={findToggle} />
            </div>
        </>
    );
}






export default Login;
